import { Injectable } from '@angular/core';
import { HttpService } from '@api/http';
import { PingServerService } from '@domain/business-layer';
import { Observable } from 'rxjs';
import {
	ExternalTransferHeadersRequestDto,
	TransferBaseRequestDto,
	TransferBaseResponseDto,
	ExternalTransferRequestDto,
	ExternalTransferHeadersResponseDto,
	ExternalTransferResponseDto,
	ExternalTransferOnlyStructureDto,
	ExternalTransferOnlyStructureResponseDto,
	CheckOutRecordDto
} from './dtos';
import { TransferRecordDto } from './dtos/transfer-record.dto';
import { UrlPathsEnum } from './models/url-paths-enum';

@Injectable({ providedIn: 'root' })
export class ExternalTransferApiService {
	public constructor(
		private httpService: HttpService,
		private pingServerService: PingServerService
	) {}

	public pingApi(serverUrl: string): Observable<string[]> {
		return this.pingServerService.testServerUrl(serverUrl, UrlPathsEnum.status);
	}

	public getDataSources(connectionId: string): Observable<string[]> {
		return this.httpService.get(connectionId, UrlPathsEnum.datasources);
	}

	public getSstnLoggingStyles(
		connectionId: string,
		requestPayload: TransferBaseRequestDto
	): Observable<TransferBaseResponseDto> {
		return this.httpService.post(connectionId, UrlPathsEnum.sstnLoggingStyles, requestPayload);
	}

	public getDhlLoggingStyles(
		connectionId: string,
		requestPayload: TransferBaseRequestDto
	): Observable<TransferBaseResponseDto> {
		return this.httpService.post(connectionId, UrlPathsEnum.dhlLoggingStyles, requestPayload);
	}

	public getBusinessUnits(
		connectionId: string,
		requestPayload: TransferBaseRequestDto
	): Observable<TransferBaseResponseDto> {
		return this.httpService.post(connectionId, UrlPathsEnum.businessUnits, requestPayload);
	}

	public getExternalTransferHeaders$(
		connectionId: string,
		requestPayload: ExternalTransferHeadersRequestDto
	): Observable<ExternalTransferHeadersResponseDto> {
		return this.httpService.post(connectionId, UrlPathsEnum.externalTransferHeader, requestPayload);
	}

	public getExternalTransfer$(
		connectionId: string,
		requestPayload: ExternalTransferRequestDto
	): Observable<ExternalTransferResponseDto> {
		return this.httpService.post(connectionId, UrlPathsEnum.externalTransfer, requestPayload);
	}

	public exportOnlyStructure(
		connectionId: string,
		requestPayload: ExternalTransferOnlyStructureDto
	): Observable<ExternalTransferOnlyStructureResponseDto> {
		return this.httpService.post(connectionId, UrlPathsEnum.export, requestPayload);
	}

	public copyIn(connectionId: string, id: TransferRecordDto) {
		return this.httpService.post(connectionId, UrlPathsEnum.copyin, id);
	}

	public checkIn(connectionId: string, id: TransferRecordDto) {
		return this.httpService.post(connectionId, UrlPathsEnum.checkin, id);
	}

	public checkOut(connectionId: string, id: CheckOutRecordDto) {
		return this.httpService.post(connectionId, UrlPathsEnum.checkout, id);
	}
}
